import styled from 'styled-components';

export const StyledSpan = styled.span`
    white-space: ${({ $pre }) => ($pre ? 'pre' : 'normal')};
    word-break: ${({ $break }) => ($break ? 'break-word' : 'normal')};
`;
